import React from 'react';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { Box } from '@mui/material';

import magicLink from 'src/assets/images/magic-link.png';
import LandingPageLayout from 'src/components/reusable-components/landing-page-layout';

const MagicLink: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation('authentication-wall');
  const { hash } = useLocation();
  const { username } = queryString.parse(hash);

  return (
    <LandingPageLayout>
      <Box
        alt={t('magicLink.imageAlt')}
        component='img'
        src={magicLink}
        sx={{ height: '168px', width: '168px' }}
      />
      <Box
        component='h2'
        sx={{
          color: 'var(--mui-palette-primary-500)',
          fontSize: 'var(--font-size-xl)',
          fontWeight: 'var(--font-weight-bold)',
        }}
      >
        {t('magicLink.title')}
      </Box>
      <Box
        component='p'
        sx={{ fontSize: 'var(--font-size-ms)', lineHeight: '21px' }}
      >
        {t('magicLink.sentTo')}{' '}
        {username && (
          <>
            <b>{username}</b> {t('magicLink.to')}{' '}
          </>
        )}
        {t('magicLink.body')}
      </Box>
    </LandingPageLayout>
  );
};

export default MagicLink;
